export default number => number > 9 ? '9+' : number;
